import { Outlet } from 'react-router-dom';
import { FiSun, FiMoon } from 'react-icons/fi';
import { useTheme } from '@/hooks/useTheme';
import Sidebar from '@/components/admin/Sidebar';

export default function AdminLayout() {
  const { theme, toggleTheme } = useTheme();

  return (
    <div className="min-h-screen flex">
      <Sidebar />
      <div className="flex-1 flex flex-col">
        <header className="bg-gray-900 border-b border-gray-800 px-6 py-4 shadow-md">
          <div className="flex items-center justify-between">
            <h2 className="text-xl font-semibold text-gray-100 tracking-tight">
              Hệ thống quản trị
            </h2>

            <div className="flex items-center space-x-4">
              <button className="text-gray-400 hover:text-white transition-colors duration-300">
                <i className="ri-notification-line text-xl"></i>
              </button>

              <button
                onClick={toggleTheme}
                className="
          relative flex items-center justify-center
          w-10 h-10 rounded-full
          bg-gray-800 text-yellow-400
          shadow-md hover:shadow-lg
          transition-all duration-300
          transform hover:scale-110
        "
                title={
                  theme === 'dark' ? 'Chuyển sang sáng' : 'Chuyển sang tối'
                }
              >
                {theme === 'dark' ? <FiSun size={20} /> : <FiMoon size={20} />}
              </button>

              <div className="flex items-center space-x-2">
                <img
                  src="https://readdy.ai/api/search-image?query=professional%20admin%20user%20avatar%20with%20modern%20tech%20background%2C%20clean%20minimal%20design%2C%20corporate%20style&width=40&height=40&seq=admin-avatar&orientation=squarish"
                  alt="Admin"
                  className="w-8 h-8 rounded-full border-2 border-gray-800"
                />
                <span className="text-gray-100 text-sm font-medium">Admin</span>
              </div>
            </div>
          </div>
        </header>

        <main className="flex-1 p-6 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
